import { EnvironmentConfiguration } from '@/config/environments/environment-configuration'
import Home from '@/business/home/pages/home.vue'

export const config: EnvironmentConfiguration = {
  analytics: {
    enabled: true,
    id: 'UA-159149608-1',
  },
  branding: null,
  cookieConsent: true,
  home: Home,
  host: 'https://www.respondeco.org',
  logLevel: 'INFO',
}
